import { Pipe, PipeTransform } from "@angular/core";
import { KanbanPedido } from "../kanbam/KanbamPedido";
import { KanbanService } from "../services/kanban.service";

@Pipe({
  name: "filtroExibicaoPedido",
})
export class FiltroExibicaoPedidoPipe implements PipeTransform {

  constructor(private kanbanService: KanbanService) {
  }

  transform(kanbamPedido: KanbanPedido, filtroExibicao: string, filtroBusca = ""): boolean {
    const pedido = kanbamPedido.pedido;
    let exibir = true;
    if (filtroBusca !== "") {
      filtroBusca = filtroBusca.toLocaleLowerCase();
      console.log(filtroBusca, "filtroBusca");
      exibir =
        pedido?.Pedido?.Nome.toLocaleLowerCase().includes(filtroBusca) ||
        pedido?.id.toLocaleLowerCase().includes(filtroBusca);
    }

    return exibir && this.kanbanService.pedidoPassouNoFiltro(kanbamPedido);

    // if (filtroExibicao === "Todos") {
    //   return exibir;
    // } else if (filtroExibicao === "Atrasados") {
    //   return exibir && Number(pedido.TempoRestante) < 0;
    // } else if (filtroExibicao === "Entrega") {
    //   return exibir && pedido.Pedido.OpcaoEntrega === "E";
    // } else if (filtroExibicao === "Retirada") {
    //   return exibir && pedido.Pedido.OpcaoEntrega === "R";
    // } else if (filtroExibicao === "Consumo") {
    //   return (
    //     exibir &&
    //     (pedido.Pedido.OpcaoEntrega === "L" ||
    //       pedido.Pedido.OpcaoEntrega === "C")
    //   );
    // }
  }
}
